// const path =
//   "https://aa43pbfsgc4fl3juoz4z6i2hae0hshwd.lambda-url.ap-south-1.on.aws";

//const path = "https://io3ec3qv8l.execute-api.us-east-2.amazonaws.com";
const path =
  "https://cvmmo54ngyaurza2cfvpyo4nfu0pbfey.lambda-url.ap-south-1.on.aws";
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
};
export const basePath = path;
export const apiPath = basePath + "/api";
export const apiLoginUser = "/admin/login";
export const apiLogutUser = "/admin/logout";
export const apiGetUser = "/admin/user";
export const apiRegisterUser = "/admin/register";
export const apiGetAllUser = "/admin/getAllUser?limit=";
export const apiDashboardStats = "/admin/dashboard-stats";
export const apiGetUserById = "/admin/user/";
export const apiExportUsers = "/admin/export-users";
export const apiBusinessCategories = "/admin/business-categories";
export const apiBulkUpload = "/admin/bulk-upload";
export const apiDownloadTemplate = "/admin/download-template";
export const apiAttendeeTypes = "/admin/attendee-types";
